<template>
  <div>
    <el-table
      v-loading="pictLoading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-text="数据正在加载中"
      element-loading-spinner="el-icon-loading"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#444455',
        backgroundColor: 'rgb(180, 211, 238)'
      }"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="channelNo" label="通道" width="70" align="center">
      </el-table-column>
      <el-table-column
        prop="sensorType"
        label="传感器类型"
        width="115"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.edit">
            {{
              channelTypeList.find(item => item.typeId == scope.row.typeId) ==
              undefined
                ? scope.row.typeName
                : channelTypeList.find(item => item.typeId == scope.row.typeId)
                    .typeName
            }}
          </span>
          <el-select v-else v-model="scope.row.typeId">
            <el-option
              v-for="item in channelTypeList"
              :key="item.typeId"
              :value="item.typeId"
              :label="item.typeName"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="height" label="安装高度" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.edit">{{ scope.row.height }}</span>
          <el-input v-else type="text" v-model="scope.row.height"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="unitName"
        label="测量单位"
        min-width="60"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.edit">{{ scope.row.unitName }}</span>
          <el-input v-else type="text" v-model="scope.row.unitName"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.edit">{{ scope.row.description }}</span>
          <el-input
            v-else
            type="text"
            v-model="scope.row.description"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="avgVal"
        label="平均值"
        min-width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="minVal"
        label="最小值"
        min-width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="maxVal"
        label="最大值"
        min-width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" min-width="80" align="center">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <el-button
              v-show="ifUpdate == 1"
              type="text"
              icon="el-icon-edit-outline"
              @click="doEdit(scope.$index, scope.row)"
            ></el-button>
          </template>
          <template v-else>
            <el-button
              v-show="ifUpdate == 1"
              type="text"
              icon="el-icon-check"
              @click="doSave(scope.$index, scope.row)"
            ></el-button>
            <el-button
              v-show="ifUpdate == 1"
              type="text"
              icon="el-icon-close"
              @click="doClose(scope.$index, scope.row)"
            ></el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    channelTypeList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ifUpdate: {
      type: Number
    }
  },
  data() {
    return {
      pictLoading: false
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    },
    doEdit(index, row) {
      //console.log('index:', index);
      //console.log('row:', row);
      row.tem_typeId = row.typeId;
      row.tem_height = row.height;
      row.tem_unitName = row.unitName;
      row.tem_description = row.description;
      row.tem_state = row.state;
      row.edit = true;
    },
    doClose(index, row) {
      //console.log('index:', index);
      //console.log('row:', row);
      row.typeId = row.tem_typeId;
      row.height = row.tem_height;
      row.unitName = row.tem_unitName;
      row.description = row.tem_description;
      row.state = row.tem_state;
      row.edit = false;
    },
    doSave(index, row) {
      let { height, description, channelId, state, unitName, typeId } =
        row || {};
      if (isNaN(height)) {
        return this.$message.error('安装高度 ' + height + ' 不是数字！');
      }
      if (unitName && unitName.length > 10) {
        return this.$message.error(
          '测量单位长度最多为10， ' + unitName + ' 长度超长！'
        );
      }
      if (description && description.length > 20) {
        return this.$message.error(
          '描述长度最多为20， ' + description + ' 长度超长！'
        );
      }
      //console.log('index:', index);
      //console.log('row:', row);
      this.$fetch('/winddata/tower/updChannelInfo', {
        module: 'windData',
        method: 'POST',
        showSuccess: true,
        showLoading: true,
        data: {
          channelId,
          description,
          height,
          state,
          typeId,
          unitName
        }
      }).then(res => {
        if (res.code == 0) {
          row.edit = false;
        }
      });
    }
  }
};
</script>

<style></style>
